import React from "react";

const TravelFromSkeleton = () => {
  const SkeletonField = ({ col }) => (
    <div className={`flex flex-col ${col}`}>
      <div className="mb-2 h-2.5 w-1/3 rounded-full bg-gray-200"></div>
      <div className="h-[48px] w-full rounded-lg border border-gray-100 bg-gray-50/80"></div>
    </div>
  );

  return (
    <div className="grid animate-pulse grid-cols-1 items-start gap-6 lg:grid-cols-12">
      <div className="sticky top-6 flex flex-col gap-3 lg:col-span-4 xl:col-span-4">
        <div className="flex h-[68px] w-full items-center justify-between rounded-lg border border-gray-200 bg-gray-100 px-5 shadow-sm ring-2 ring-gray-100">
          <div className="h-4 w-1/2 rounded-full bg-gray-300"></div>
          <div className="h-8 w-20 rounded-lg bg-gray-300"></div>
        </div>

        {[1, 2, 3, 4].map((item) => (
          <div
            key={item}
            className="flex h-[68px] w-full items-center justify-between rounded-lg border border-gray-100 bg-white px-5 shadow-sm">
            <div className="h-4 w-5/12 rounded-full bg-gray-200"></div>
            <div className="h-8 w-20 rounded-lg bg-gray-100"></div>
          </div>
        ))}
      </div>
      <div className="rounded-lg border border-gray-100 bg-white p-6 shadow-sm md:p-8 lg:col-span-8 xl:col-span-8">
        <div className="mb-8 flex items-center gap-3 border-b border-gray-50 pb-5">
          <div className="h-10 w-10 rounded-lg bg-gray-200"></div>
          <div className="h-7 w-48 rounded-full bg-gray-200"></div>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-12">
          <SkeletonField col="md:col-span-12 lg:col-span-4" />
          <SkeletonField col="md:col-span-12 lg:col-span-4" />
          <SkeletonField col="md:col-span-6 lg:col-span-4" />

          <SkeletonField col="md:col-span-4" />
          <SkeletonField col="md:col-span-4" />
          <SkeletonField col="md:col-span-4" />

          <SkeletonField col="md:col-span-6 lg:col-span-4" />
          <SkeletonField col="md:col-span-4" />
          <SkeletonField col="md:col-span-4" />

          <SkeletonField col="md:col-span-4" />
          <SkeletonField col="md:col-span-12 lg:col-span-8" />

          <SkeletonField col="md:col-span-12 lg:col-span-4" />
          <SkeletonField col="md:col-span-12 lg:col-span-4" />
          <SkeletonField col="md:col-span-12 lg:col-span-4" />
        </div>
      </div>
    </div>
  );
};

export default TravelFromSkeleton;
